import styled from 'styled-components';

export const ItemName = styled.h3`
  margin-block-start: 0;
  text-align: center;
`;
